@if (responsiveService.mobile()) {
    <woa-full-page-layout class="mobile-page"
                          [showNavbar]="false" [pillarboxedOnMobile]="'none'"
                          [makeFloatingBackButtonCircular]="!mobileHeaderStuck()"
                          [showContent]="contentVisible()" [showFooterShadow]="true">
        @if (productImage()?.id) {
            <div class="item-image">
                @if (menuItem().promotedFeatureTag) {
                    <div class="item-image-feature-tag">
                        {{ menuItem().promotedFeatureTag }}
                    </div>
                }
                <img class="item-image-object" alt="" [woa-image-cache]="productImage()" >
            </div>
        }
        @if (contentVisible()) {
            <div class="item-body" [ngClass]="{'with-image': !!productImage()}">
                @if (!singleItem()) {
                    <div class="item-body-deal-header">
                        <div class="item-body-deal-header-title">
                            {{ title() | translate: titleParams() }}
                        </div>
                        @if (dealModel.pendingDeal()?.description) {
                            <div class="item-body-deal-header-subtitle">
                                {{ subtitle() | translate: titleParams() }}
                            </div>
                        }
                    </div>
                }
                <div class="item-body-item-header" woa-sticky [topMargin]="35" [minHeight]="63" [delay]="750"
                     (onStuckChange)="mobileHeaderStuck.set($event)">
                    <div class="item-body-item-header-title">
                        <div class="item-body-item-header-title-text">
                            {{ 'woa.heading.order.item-edit.itemTitle' | translate: titleParams() }}
                        </div>
                        @if (!informational() && configurationModel.showOrderItemNotes()) {
                            <woa-link class="item-body-item-header-title-notes"
                                      [link]="(orderItem().itemNotesSignal() ? 'woa.button.order.notes.edit' : 'woa.button.order.notes.add')"
                                      (onActivate)="editNotes()"></woa-link>
                        }
                    </div>
                </div>
                <div class="item-body-details">
                    @if (menuModel.getSellableExternalDescription(orderItem().sellable())) {
                        <div class="item-body-details-description"
                            [innerHtml]="menuModel.getSellableExternalDescription(orderItem().sellable()) | html"></div>
                    }
                    <woa-dietary-panel class="item-body-details-dietary"
                                       [sellable]="orderItem().sellable()"></woa-dietary-panel>
                    @if (!informational() && orderItem().itemNotesSignal()) {
                        <woa-content-message class="item-body-details-notes"
                                             [level]="MessageLevel.SUCCESS" [icon]="'pen-circle'"
                                             [linkLayout]="MessageLayout.HORIZONTAL"
                                             [text]="orderItem().itemNotesSignal() | literal">
                            <woa-link [link]="'woa.button.common.edit'" [plain]="true"
                                      (onActivate)="editNotes()"></woa-link>
                            <woa-link [link]="'woa.button.common.remove'" [plain]="true"
                                      (onActivate)="removeNotes()"></woa-link>
                        </woa-content-message>
                    }
                </div>
                @if (!informational()) {
                    <woa-order-item-options-panel [orderItem]="orderItem()" [originalOrderItem]="originalOrderItem()"
                                                  [category]="category()" [showSizes]="singleItem()"
                                                  (onExtraChange)="setExtraGroupInteracted($event)"
                                                  (onSizeSelect)="sizeSelected($event)"></woa-order-item-options-panel>
                    @if (configurationModel.app()?.dietaryStatement && configurationModel.isConsumerActor()) {
                        <woa-content-message class="item-body-statement" [level]="MessageLevel.INFO"
                                             [text]="configurationModel.app()?.dietaryStatement | literal"></woa-content-message>
                    }
                }
            </div>
        }
        @if (showItemWaitTimeInfo()) {
            <woa-footer-message [level]="MessageLevel.INFO" [icon]="'clock-three'"
                                [text]="'woa.message.order.itemWaitTimeInfo'"
                                [translationParams]="{'itemWaitTime': menuItem().sellable.standardWaitTimeMinutes}"></woa-footer-message>
        }
        @if (showItemWaitTimeWarning()) {
            <woa-footer-message [level]="MessageLevel.WARNING" [icon]="'clock-three'"
                                [text]="'woa.message.order.itemWaitTimeWarning'"
                                [translationParams]="{'itemWaitTime': menuItem().sellable.currentWaitTimeMinutes}"></woa-footer-message>
        }
        @if (!informational()) {
            <div class="item-footer" slot="footer-end">
                <woa-order-item-quantity-control class="item-footer-quantity" [orderItem]="orderItem()"
                                                 [originalOrderItem]="originalOrderItem()"
                                                 [allowZeroQuantity]="editing()"></woa-order-item-quantity-control>
                <woa-button class="item-footer-button" id="mobile-add-to-order-button" [label]="addItemToOrderLabel()"
                            [connotation]="orderItem().quantitySignal() ? ButtonConnotation.AFFIRMATIVE : ButtonConnotation.NEGATIVE"
                            [prominence]="orderItem().quantitySignal() ? ButtonProminence.HIGH : ButtonProminence.LOW"
                            [translationParams]="{
                                'qty': orderItem().debouncedQuantitySignal(),
                                'price': orderItem().debouncedLocalTotalSignal() | woaCurrency,
                                'nrItems': itemsToOrder()?.length
                            }"
                            (onActivate)="confirmItem()"></woa-button>
            </div>
        }
    </woa-full-page-layout>
}
@if (responsiveService.desktop()) {
    <woa-modal-page-layout class="desktop-page"
                           [title]="title()" [subtitle]="subtitle()" [translationParams]="titleParams()"
                           [customGeometry]="desktopCustomGeometry()"
                           [showContent]="contentVisible()"
                           [showSubtitle]="!singleItem() && !!dealModel.pendingDeal()?.description">
        <div class="item" [ngClass]="{'simple': !showDesktopOptionsPanel()}">
            <div class="item-summary" #summary [style.top]="desktopContentStickyTop()(summary)">
                @if (productImage()?.id) {
                    <div class="item-summary-image">
                        <img class="item-summary-image-object" alt="" [woa-image-cache]="productImage()">
                        @if (menuItem().promotedFeatureTag) {
                            <div class="item-summary-image-tag">
                                {{ menuItem().promotedFeatureTag }}
                            </div>
                        }
                    </div>
                }
                <div class="item-summary-details" [ngClass]="{'with-image': productImage()?.id}">
                    @if (!singleItem() || configurationModel.showOrderItemNotes()) {
                        <div class="item-summary-details-title" [ngClass]="{'with-item-title': !singleItem()}">
                            @if (!singleItem()) {
                                <div class="item-summary-details-title-text">
                                    {{ 'woa.heading.order.item-edit.itemTitle' | translate: titleParams() }}
                                </div>
                            }
                            @if (!informational() && configurationModel.showOrderItemNotes()) {
                                <woa-link class="item-summary-details-title-notes"
                                          [link]="(orderItem().itemNotesSignal() ? 'woa.button.order.notes.edit' : 'woa.button.order.notes.add')"
                                          (onActivate)="editNotes()"></woa-link>
                            }
                        </div>
                    }
                    @if (menuModel.getMenuItemDescription(menuItem())) {
                        <div class="item-summary-details-description"
                             [innerHtml]="menuModel.getMenuItemDescription(menuItem()) | html"></div>
                    }
                    <woa-dietary-panel class="item-summary-details-dietary"
                                       [sellable]="menuItem().sellable"></woa-dietary-panel>
                    @if (!informational()) {
                        @if (orderItem().itemNotesSignal()) {
                            <woa-content-message class="item-summary-details-notes"
                                                 [level]="MessageLevel.INFO" [icon]="'pen-circle'"
                                                 [linkLayout]="MessageLayout.HORIZONTAL"
                                                 [text]="orderItem().itemNotesSignal() | literal">
                                <woa-link [link]="'woa.button.common.edit'" [plain]="true"
                                          (onActivate)="editNotes()"></woa-link>
                                <woa-link [link]="'woa.button.common.remove'" [plain]="true"
                                          (onActivate)="removeNotes()"></woa-link>
                            </woa-content-message>
                        }
                        @if (!showDesktopOptionsPanel()) {
                            <woa-order-item-options-panel [orderItem]="orderItem()" [originalOrderItem]="originalOrderItem()"
                                                          [category]="category()" [showOptions]="false"
                                                          (onExtraChange)="setExtraGroupInteracted($event)"
                                                          (onSizeSelect)="sizeSelected($event)"></woa-order-item-options-panel>
                        }
                    }
                    @if (configurationModel.app()?.dietaryStatement && configurationModel.isConsumerActor()) {
                        <woa-content-message class="item-summary-details-statement"
                                             [level]="MessageLevel.INFO"
                                             [text]="configurationModel.app()?.dietaryStatement | literal"></woa-content-message>
                    }
                </div>
            </div>
            @if (showDesktopOptionsPanel()) {
                <div class="item-options" #options [style.top]="desktopContentStickyTop()(options)">
                    <woa-order-item-options-panel [orderItem]="orderItem()" [originalOrderItem]="originalOrderItem()"
                                                  [category]="category()" [showSizes]="singleItem()"
                                                  (onExtraChange)="setExtraGroupInteracted($event)"
                                                  (onSizeSelect)="sizeSelected($event)"></woa-order-item-options-panel>
                </div>
            }
        </div>
        @if (showItemWaitTimeInfo()) {
            <woa-footer-message [level]="MessageLevel.INFO" [icon]="'clock-three'"
                                [text]="'woa.message.order.itemWaitTimeInfo'"
                                [translationParams]="{'itemWaitTime': menuItem().sellable.standardWaitTimeMinutes}"></woa-footer-message>
        }
        @if (showItemWaitTimeWarning()) {
            <woa-footer-message [level]="MessageLevel.WARNING" [icon]="'clock-three'"
                                [text]="'woa.message.order.itemWaitTimeWarning'"
                                [translationParams]="{'itemWaitTime': menuItem().sellable.currentWaitTimeMinutes}"></woa-footer-message>
        }
        @if (!informational()) {
            <woa-order-item-quantity-control woa-page-footer-control [orderItem]="orderItem()"
                                             [originalOrderItem]="originalOrderItem()"
                                             [allowZeroQuantity]="editing()"></woa-order-item-quantity-control>
        }
        @if (!informational()) {
            <woa-button woa-page-footer-control id="desktop-add-to-order-button" [label]="addItemToOrderLabel()"
                        [connotation]="orderItem().quantitySignal() ? ButtonConnotation.AFFIRMATIVE : ButtonConnotation.NEGATIVE"
                        [prominence]="orderItem().quantitySignal() ? ButtonProminence.HIGH : ButtonProminence.LOW"
                        [translationParams]="{
                            'qty': orderItem().debouncedQuantitySignal(),
                            'price': orderItem().debouncedLocalTotalSignal() | woaCurrency,
                            'nrItems': itemsToOrder()?.length
                        }"
                        (onActivate)="confirmItem()"></woa-button>
        }
    </woa-modal-page-layout>
}
